import { Trans, useTranslation } from "next-i18next";
import styles from "./CountriesBenefitsRequirements.module.scss";

const CountriesBenefitsRequirements = () => {
  const {t} = useTranslation("olympiad")

  return (
    <section className={styles.BenefitsRequirementContainer}>
      <article className={styles.benefits}>
        <h3>{t("countries.benefits-title")}</h3>
        <p>
          <Trans
            t={t}
            i18nKey={"countries.benefits-text"}
          />
        </p>
      </article>
      <article className={styles.requirements}>
        <h3>{t("countries.requirements-title")}</h3>
        <p>
          <Trans
            t={t}
            i18nKey={"countries.requirements-text"}
          />
        </p>
      </article>
    </section>
  );
}

export default CountriesBenefitsRequirements;